export const EXSBINVOICESTATUS_DELETE_RESET = 'EXSBINVOICESTATUS_DELETE_RESET'
export const EXSBINVOICESTATUS_DELETE_SET_ERROR = 'EXSBINVOICESTATUS_DELETE_SET_ERROR'
export const EXSBINVOICESTATUS_DELETE_SET_DELETED = 'EXSBINVOICESTATUS_DELETE_SET_DELETED'
export const EXSBINVOICESTATUS_DELETE_TOGGLE_LOADING = 'EXSBINVOICESTATUS_DELETE_TOGGLE_LOADING'
